import React from 'react'
import { Spinner } from "@nextui-org/react";

function Loading({ isLoading }) {

    return (
        <>
            {isLoading && (
                <div className='flex justify-center items-center mb-3'>
                    <Spinner
                        color="success"
                    />
                </div>
            )}
        </>
    )
}

export default Loading